module.exports = __webpack_public_path__ + "static/lewandowski_main_3-7e33db5285f906f804043f9d24e053b3.png";